import { ICondition } from "../State";

export default class AlwaysTrueCondition implements ICondition {
    public check(): boolean {
        return true;
    }
}